import { Vue,Component,Emit,Prop,Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';
import store from '@/assets/common/store/store';
import { LoginUser} from "@/types/Component";


@Component({
    components: {
        Modal,
        EmptyGraphMessage
    }
})
export default class ChemicalPointListModal extends Vue {
    
    private list: any | null = null
    private items: any = []
    private baseUrl = '/chemical_points_list';
    private isLoading = false
    private headerTitle!: string
    private alteredChemicalPoints = false
    private startChemicalId = ''
    private endChemicalId = ''
    private chemicalName = ''
    private makerName = ''
    private ingName = ''
    private chemicalPointList =  [] as any[];
    private sortOrder = true;
    private changedChemicalPoints = [] as any[]; 
    isReadOnly = false;
    private sortType = "";
    private alertMessage = 'リクエストに失敗しました。\n'

    isNoyakuNavi!: boolean
    private tempShippingOrganizationId = ""
    private shippingGroupList =  [] as any[];
    private selectedShippingGroupId = '';
    private showPageUp = false
    private showPageBottom = false

    @Prop() 
    isShowChemicalPointListModal!: boolean

    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    get pesticidePlanProducer() : boolean {
      return this.loginUser.pesticidePlanProducer;
    }

    /**
     * 農薬プランかどうかを判定する
     * @returns 農薬プランフラグ
     */
    get isPesticidePlan() : boolean {
        return this.loginUser.isPesticidePlan;
    }

    /**
     * 農薬点数一覧モーダル表示監視
     * 表示時に農薬点数一覧を取得する
     */
    @Watch('isShowChemicalPointListModal')
    private showChemicalPointList() {
        if(this.isShowChemicalPointListModal){
            this.isLoading = true
            this.getChemicalPoints();
        }
    }

    @Watch('isShowChemicalPointListModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
    }

    /**
     * 農薬点数一覧をAPIから取得する
     * 検索条件を指定して農薬点数データを取得する
     */
    private getChemicalPoints() {
        this.chemicalPointList = []
        this.$apiClient.doRequest('get', `${this.baseUrl}?start_chem_id=${this.startChemicalId || 'null'}&end_chem_id=${this.endChemicalId || 'null'}&chemical_name=${this.chemicalName || 'null'}&maker_name=${this.makerName || 'null'}&ingredient_name=${this.ingName || 'null'}&tenant_id=${this.tempShippingOrganizationId || 'null'}`).then(res => {
            this.chemicalPointList = res.chemicalPointsList
            this.shippingGroupList = res.getNameAndCompany
            if(this.shippingGroupList && this.shippingGroupList.length > 0) {
                if (!this.tempShippingOrganizationId) {
                    this.tempShippingOrganizationId = this.shippingGroupList[0].tenant_id
                }
            }
            this.chemicalPointList.forEach((chemicalItem: any) => {
                this.initializePointsEquality(chemicalItem);
            });
            this.isLoading = false;
        });
    }

    /**
     * 編集をキャンセルする
     * 変更がある場合は確認ダイアログを表示し、OKの場合のみ破棄する
     */
    private cancelEdit() {
        if(!this.alteredChemicalPoints){
            window.alert("変更はありません。")
            return false;
        }
        if (this.alteredChemicalPoints) {
            const confirmed = window.confirm("変更内容を破棄します。よろしいですか？");
            if (!confirmed) {
                return;
            }
            this.isLoading = true
            this.getChemicalPoints();
        }
        this.alteredChemicalPoints = false;
    }
    
    /**
     * 入力変更イベント
     * 農薬点数変更フラグをtrueに設定する
     */
    @Emit('inputChanged')
    inputChanged(){
        if(this.alteredChemicalPoints == false){
            this.alteredChemicalPoints = true
        }
    }

    /**
     * モーダルを閉じる
     * 変更がある場合は確認ダイアログを表示し、検索条件を初期化する
     */
    closeModal(){
        if (this.alteredChemicalPoints && !window.confirm("変更内容を破棄します。よろしいですか？")) {
            return;
        }
        this.$emit('update:isShowChemicalPointListModal', false);
        this.alteredChemicalPoints= false
        this.changedChemicalPoints = []
        this.startChemicalId = ''
        this.endChemicalId = ''
        this.chemicalName = ''
        this.makerName = ''
        this.ingName = ''
        this.tempShippingOrganizationId = ''
    }
    
    /**
     * 検索処理
     * 検索条件で農薬点数一覧を再取得する
     */
    handleSearch() {
        this.chemicalPointList = []
        this.isLoading = true
        this.getChemicalPoints();   
    }

    /**
     * ソート処理
     * 指定されたフィールド名で農薬点数一覧をソートする
     * @param fieldName ソート対象フィールド名
     */
    private sort(fieldName: string): void {
        this.sortOrder = !this.sortOrder;
        this.chemicalPointList.sort((a, b) => {
            const aValue = a[fieldName];
            const bValue = b[fieldName];
            if (aValue === null && bValue === null) return 0;
            if (aValue === null) return 1;
            if (bValue === null) return -1;
            const aNum = Number(aValue);
            const bNum = Number(bValue);
            const isANum = !isNaN(aNum);
            const isBNum = !isNaN(bNum);
            if (isANum && isBNum) {
                return this.sortOrder ? aNum - bNum : bNum - aNum;
            }
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                return this.sortOrder
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            }
            return this.sortOrder
                ? String(aValue).localeCompare(String(bValue))
                : String(bValue).localeCompare(String(aValue));
        });
    }

    /**
     * 合計点数を計算する
     * 農薬ごとの成分点数の合計を算出する
     * @param chemicalList 農薬情報
     * @returns 合計点数
     */

    calculateTotalPoints(chemicalList:any) {
        if (!chemicalList.ingInfos || chemicalList.ingInfos.length === 0) {
        return 0;
        }

        return chemicalList.ingInfos.reduce((total:any, ingInfo:any) => {
            let point: number;
    
            if (ingInfo.ingPoints !== null && ingInfo.ingPoints !== undefined) {
                point = parseInt(ingInfo.ingPoints) || 0;
            } else {
                point = parseInt(ingInfo.pointValue) || 0;
            }
            return total + point;
        }, 0);
    }

   /**
     * 最大成分情報数を取得する
     * 一覧表示用の列数を算出する
     * @returns 最大成分情報数
     */ 
   get maxIngInfosCount() {
        if (!this.chemicalPointList || this.chemicalPointList.length === 0) {
            return 0;
        }
        
        const maxLength = Math.max(...this.chemicalPointList.map(item => 
        item.ingInfos ? item.ingInfos.length : 0
        ));
        
        return maxLength;
    }

    /**
     * 表示用の点数を取得する
     * @param listIndex 一覧インデックス
     * @param itemIndex アイテムインデックス
     * @returns 表示用点数
     */
    getDisplayValue(listIndex: number, itemIndex: number) {
        const chemicalItem = this.chemicalPointList[listIndex];
        const ingInfo = chemicalItem.ingInfos[itemIndex-1];
        return ingInfo.ingPoints != null ? ingInfo.ingPoints : ingInfo.pointValue;
    }
    
    /**
     * 農薬点数変更処理
     * 入力値の変更を検知し、変更済みリストに追加/更新する
     * @param event イベントオブジェクト
     * @param listIndex 一覧インデックス
     * @param itemIndex アイテムインデックス
     */

    handleChemicalPointChange(event: any, listIndex: number, itemIndex: number) {
        const newValue = event.target.value;
        const chemicalItem = this.chemicalPointList[listIndex];
        const isExist = chemicalItem.isExist
        
        if (!chemicalItem || !chemicalItem.ingInfos) return;
        
        const ingInfo = chemicalItem.ingInfos[itemIndex-1];
        if (!ingInfo) return;
        
        const originalValue = ingInfo.ingPoints != null ? ingInfo.ingPoints : ingInfo.pointValue;
        
        if (newValue !== String(originalValue)) {
            ingInfo.ingPoints = newValue;
            const chemicalId = chemicalItem.chemicalId;
            const basicBranchNum = ingInfo.branchNum;
            
            let processType;
            if (ingInfo.updated == null) {
                processType = 'ADD';
            } else if (isExist == true && ingInfo.ingPoints === ingInfo.pointValue) {
                processType = 'DELETE'; 
            } else {
                processType = 'UPDATE';
            }

            // SKIP PUSHING if ADD operation AND new value equals original pointValue
            if (processType === 'ADD' && newValue === String(ingInfo.pointValue)) {
                // Don't push to changedChemicalPoints array
                const existingIndex = this.changedChemicalPoints.findIndex(
                    item => item.chemicalId === chemicalId && 
                            item.basicBranchNum === basicBranchNum &&
                            item.processType === 'ADD'
                );
                
                if (existingIndex >= 0) {
                    this.changedChemicalPoints.splice(existingIndex, 1);
                }
                chemicalItem.isAllPointsEqual = this.areAllPointsEqual(chemicalItem);
                this.initializePointsEquality(chemicalItem);
                this.inputChanged();
                return;
            }
            const existingIndex = this.changedChemicalPoints.findIndex(
                item => item.chemicalId === chemicalId && 
                    item.basicBranchNum === basicBranchNum
            );
            const numericValue = newValue || null;
            if (existingIndex >= 0) {
                this.changedChemicalPoints[existingIndex].ingPoints = numericValue;
                this.changedChemicalPoints[existingIndex].processType = processType;
            } else {
                this.changedChemicalPoints.push({
                    chemicalId: chemicalId,
                    basicBranchNum: basicBranchNum,
                    ingPoints: numericValue,
                    processType: processType,
                    updated: ingInfo.updated
                });
            }
            chemicalItem.isAllPointsEqual = this.areAllPointsEqual(chemicalItem);
            this.initializePointsEquality(chemicalItem);
            this.inputChanged();
        }
    }

     /**
     * 農薬チェック実行
     * 栽培履歴に対する農薬チェックを実行する
     */
    chemicalCheck(){        
        const confirmed = window.confirm("農薬チェックを行います。よろしいですか？");
        if (!confirmed) {
            return;
        }
        this.isLoading = true;
        this.$apiClient.doRequest("post", `${this.baseUrl}/cultivation_histories`).then((res) => {
            this.$toasted.success('農薬チェックを実行しました。')
        }).catch(() => {
            this.$toasted.error("農薬チェックに失敗しました。");
        }).finally(() => {
            this.isLoading = false;
        });
    }

    /**
     * 保存処理
     * 変更済み農薬点数をAPIに保存する
     * @returns 保存成否
     */
    save(){
        if(!this.alteredChemicalPoints){
            window.alert("変更はありません。")
            return false;
        }
        if(this.changedChemicalPoints.length > 0){
            if (!window.confirm("内容を上書きして保存します。よろしいですか。")) {
                return false;
            }
            const isChemicalCheck = window.confirm("農薬チェックを行いますか？");
            const data = {
                chemicalPoints: this.changedChemicalPoints.map(cp => ({
                    chemical_id: cp.chemicalId,
                    branch_num: cp.basicBranchNum,
                    ing_points: cp.ingPoints,
                    processType: cp.processType,
                    is_chemical_check: isChemicalCheck,
                    updated:cp.updated
                })),
            }        
            this.$apiClient.doRequest("post", `${this.baseUrl}`, data).then((res) => {
                this.isLoading = true
                if (res.message) {
                    window.alert(this.alertMessage + res.message);
                    this.$toasted.error('変更に失敗しました。')
                    this.isLoading = false
                    return;
                }
                this.getChemicalPoints();
                this.changedChemicalPoints = [];
                this.$toasted.success('保存しました。')
            })
            .catch(() => {
                this.$toasted.error('保存に失敗しました。')
            })
            this.isLoading = false
            this.alteredChemicalPoints = false
        }
    }

    /**
     * 農薬点数を初期化する
     * 指定された農薬の点数を全てnullに設定する
     * @param listIndex 一覧インデックス
     */
    private resetChemicalPoints(listIndex: number) {
        const chemicalItem = this.chemicalPointList[listIndex];
        if (!chemicalItem || !chemicalItem.ingInfos) return;
        
        const hasIngPoints = chemicalItem.ingInfos.some((ing: any) => ing.ingPoints != null);
        if (!hasIngPoints) return;
        
        if (!window.confirm('初期化しますか？')) {
            return;
        }
        
        // 各成分情報を処理
        chemicalItem.ingInfos.forEach((ingInfo: any, ingIndex: number) => {
            if (ingInfo.ingPoints != null) {
                const chemicalId = chemicalItem.chemicalId;
                const basicBranchNum = ingInfo.branchNum;
                const updated = ingInfo.updated;
                
                const existingIndex = this.changedChemicalPoints.findIndex(
                    item => item.chemicalId === chemicalId && 
                        item.basicBranchNum === basicBranchNum
                );
                
                if (existingIndex >= 0) {
                    if (updated !== null && updated !== undefined) {
                        this.changedChemicalPoints[existingIndex].processType = 'DELETE';
                        this.changedChemicalPoints[existingIndex].ingPoints = null;
                    }else{
                        this.changedChemicalPoints.splice(existingIndex, 1);
                    }
                } else {
                    if(updated !== null){
                        this.changedChemicalPoints.push({
                            chemicalId: chemicalId,
                            basicBranchNum: basicBranchNum,
                            processType: 'DELETE',
                            updated:updated
                        });
                    }
                }
                ingInfo.ingPoints = null;
            }
            this.initializePointsEquality(chemicalItem);
        });        
        this.inputChanged();
    }

    /**
     * ソート変更処理
     * 選択されたソート種別に応じてソートを実行する
     */
    private onSortChange() {
      switch (this.sortType) {
        case "chemicalId":
          this.sort('chemicalId')
          break
        case "chemicalName":
          this.sort("chemicalName")
          break
        case "makerName":
          this.sort("makerName")
          break
      }
    }

    private initializePointsEquality(chemicalItem: any): void {
        if (chemicalItem && chemicalItem.ingInfos) {
            chemicalItem.ingInfos.forEach((ingInfo: any) => {
                // Set individual ingInfo equality flag
                ingInfo.isPointsEqual = this.isPointsValueEqual(ingInfo);
            });
            // Set overall chemical item equality flag
            chemicalItem.isAllPointsEqual = this.areAllPointsEqual(chemicalItem);
        }
    }

    private areAllPointsEqual(chemicalItem: any): boolean {
        if (!chemicalItem.ingInfos || chemicalItem.ingInfos.length === 0) {
            return false;
        }
        return chemicalItem.ingInfos.every((ingInfo: any) => 
            this.isPointsValueEqual(ingInfo)
        );
    }

    private isPointsValueEqual(ingInfo: any): boolean {
        // If ingPoints is null or undefined, it means using default pointValue
        if (ingInfo.ingPoints === null || ingInfo.ingPoints === undefined) {
            return true; // null means use default value, so it's considered equal
        }
        
        // Compare as strings to handle both string and number types
        return String(ingInfo.ingPoints) === String(ingInfo.pointValue);
    }

    get selectedShippingGroupName() {
        const selected = this.shippingGroupList.find(item => item.tenant_id === this.tempShippingOrganizationId);
        if (selected) {
        const companyDisplay = selected.companyName || selected.name ;
        return `${companyDisplay}`;
       }
    }

     private handleScroll(): void {
        const el = this.$refs.popupBody as HTMLElement
        if (!el) return
    
        const scrollTop = el.scrollTop
        const scrollHeight = el.scrollHeight
        const clientHeight = el.clientHeight
    
        this.showPageUp = scrollTop > 100
    
        this.showPageBottom = scrollTop + clientHeight < scrollHeight - 10
    }
    
    private scrollToTop(): void {
        const el = this.$refs.popupBody as HTMLElement
        if (!el) return
    
        el.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }
    
    private scrollToBottom(): void {
        const el = this.$refs.popupBody as HTMLElement
        if (!el) return
    
        el.scrollTo({
            top: el.scrollHeight,
            behavior: 'smooth'
        })
    }

}      